import { render, staticRenderFns } from "./AlarmRedirect.vue?vue&type=template&id=50da9b1a&"
import script from "./AlarmRedirect.vue?vue&type=script&lang=js&"
export * from "./AlarmRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports